const Pagination = ({ currentPage, totalPages, onPageChange }) => {
  // Function to generate smart page numbers
  const getPageNumbers = () => {
    const delta = 2; // Number of pages to show on each side of current page
    const range = [];
    const rangeWithDots = [];

    // Always show first page
    range.push(1);

    // Calculate start and end of middle range
    const start = Math.max(2, currentPage - delta);
    const end = Math.min(totalPages - 1, currentPage + delta);

    // Add pages around current page
    for (let i = start; i <= end; i++) {
      range.push(i);
    }

    // Always show last page if totalPages > 1
    if (totalPages > 1) {
      range.push(totalPages);
    }

    // Remove duplicates and sort
    const uniqueRange = [...new Set(range)].sort((a, b) => a - b);

    // Add dots where there are gaps
    let prev = 0;
    uniqueRange.forEach((page) => {
      if (page - prev > 1) {
        rangeWithDots.push('...');
      }
      rangeWithDots.push(page);
      prev = page;
    });

    return rangeWithDots;
  };

  const pageNumbers = getPageNumbers();

  return (
    <div className="flex justify-center items-center space-x-2 mt-4">
      <button
        onClick={() => onPageChange(currentPage - 1)}
        disabled={currentPage === 1}
        className={`px-3 py-0 rounded-md ${currentPage === 1
          ? 'bg-[#9B7E6B]/50 cursor-not-allowed'
          : 'bg-[#9B7E6B] text-white hover:bg-[#B85C38] transition-colors duration-200'}`}
      >
        Previous
      </button>

      <div className="flex space-x-1">
        {pageNumbers.map((page, index) => {
          if (page === '...') {
            return (
              <span
                key={`dots-${index}`}
                className="w-6 h-6 flex items-center justify-center text-[#9B7E6B]"
              >
                ...
              </span>
            );
          }

          return (
            <button
              key={page}
              onClick={() => onPageChange(page)}
              className={`w-6 h-6 rounded-md ${currentPage === page
                ? 'bg-[#B85C38] text-white'
                : 'bg-[#E6CCB2] text-[#2E1F27] hover:bg-[#F2D0A9] transition-colors duration-200'}`}
            >
              {page}
            </button>
          );
        })}
      </div>

      <button
        onClick={() => onPageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
        className={`px-3 py-0 rounded-md ${currentPage === totalPages
          ? 'bg-[#9B7E6B]/50 cursor-not-allowed'
          : 'bg-[#9B7E6B] text-white hover:bg-[#B85C38] transition-colors duration-200'}`}
      >
        Next
      </button>
    </div>
  );
};

export default Pagination;